import script from "./ApprovalDetailDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./ApprovalDetailDrawer.vue?vue&type=script&setup=true&lang=js"

import "./ApprovalDetailDrawer.vue?vue&type=style&index=0&id=faf530fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-faf530fa"]])

export default __exports__